export const FETCH_ALL_ADMIN = 'FETCH_ALL_ADMIN';
export const FETCH_ALL_ADMIN_FAILED = 'FETCH_ALL_ADMIN_FAILED';
export const FETCH_ALL_ADMIN_SUCCEED = 'FETCH_ALL_ADMIN_SUCCEED';

export const FETCH_ADMINS = 'FETCH_ADMINS';
export const FETCH_ADMINS_FAILED = 'FETCH_ADMINS_FAILED';
export const FETCH_ADMINS_SUCCEED = 'FETCH_ADMINS_SUCCEED';

export const ON_CREATE_ADMIN = 'ON_CREATE_ADMIN';
export const ON_CREATE_ADMIN_SUCCEED = 'ON_CREATE_ADMIN_SUCCEED';
export const ON_CREATE_ADMIN_FAILED = 'ON_CREATE_ADMIN_FAILED';

export const FETCH_ADMIN_LOGIN_HISTORY = 'FETCH_ADMIN_LOGIN_HISTORY';
export const FETCH_ADMIN_LOGIN_HISTORY_FAILED = 'FETCH_ADMIN_LOGIN_HISTORY_FAILED';
export const FETCH_ADMIN_LOGIN_HISTORY_SUCCEED = 'FETCH_ADMIN_LOGIN_HISTORY_SUCCEED';

export const FETCH_AUTH_INFO = 'FETCH_AUTH_INFO';
export const FETCH_AUTH_INFO_FAILED = 'FETCH_AUTH_INFO_FAILED';
export const FETCH_AUTH_INFO_SUCCEED = 'FETCH_AUTH_INFO_SUCCEED';

export const GET_ROLE_FOR_USER = 'GET_ROLE_FOR_USER';
export const POST_ROLE_FOR_USER = 'POST_ROLE_FOR_USER';

export const FETCH_ADMIN_INFO = 'FETCH_ADMIN_INFO';
export const FETCH_ADMIN_INFO_FAILED = 'FETCH_ADMIN_INFO_FAILED';
export const FETCH_ADMIN_INFO_SUCCEED = 'FETCH_ADMIN_INFO_SUCCEED';

export const FETCH_LIMIT_WITHDRAWAL_OF_ADMIN = 'FETCH_LIMIT_WITHDRAWAL_OF_ADMIN';
export const FETCH_LIMIT_WITHDRAWAL_OF_ADMIN_SUCCEED = 'FETCH_LIMIT_WITHDRAWAL__OF_ADMIN_SUCCEED';
export const FETCH_LIMIT_WITHDRAWAL_OF_ADMIN_FAILED = 'FETCH_LIMIT_WITHDRAWAL_OF_ADMIN_FAILED';

export const SET_LIMIT_WITHDRAWAL_FOR_ADMIN = 'SET_LIMIT_WITHDRAWAL_FOR_ADMIN';
export const SET_LIMIT_WITHDRAWAL_FOR_ADMIN_SUCCEED = 'SET_LIMIT_WITHDRAWAL_FOR_ADMIN_SUCCEED';
export const SET_LIMIT_WITHDRAWAL_FOR_ADMIN_FAILED = 'SET_LIMIT_WITHDRAWAL_FOR_ADMIN_FAILED';

export const FETCH_ADMIN_BALANCES = 'FETCH_ADMIN_BALANCES';
export const FETCH_ADMIN_BALANCES_FAILED = 'FETCH_ADMIN_BALANCES_FAILED';
export const FETCH_ADMIN_BALANCES_SUCCEED = 'FETCH_ADMIN_BALANCES_SUCCEED';

export const FETCH_BAN_ADMIN = 'FETCH_BAN_ADMIN';
export const FETCH_UN_BAN_ADMIN = 'FETCH_UN_BAN_ADMIN';
export const FETCH_DEL_ADMIN = 'FETCH_DEL_ADMIN';

export const FETCH_OWN_BALANCE = 'FETCH_OWN_BALANCE';
export const FETCH_OWN_BALANCE_SUCCESS = 'FETCH_OWN_BALANCE_SUCCESS';
export const FETCH_OWN_BALANCE_FAILED = 'FETCH_OWN_BALANCE_FAILED';
